import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemLink, ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { URLS, Url } from '@wix/da-url';
const GoToTierDashboard = ({ deviation, stopPropagation, anchorless })=>{
    var _deviation_tier;
    const { t } = useTranslation();
    const dashboardUrl = `${Url.buildFromPath(URLS.CUSTOMER_DASHBOARD)}?subproductid=${(_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.subproductId}`;
    const openDashboard = useCallback(()=>{
        window.location.href = dashboardUrl;
    }, [
        deviation
    ]);
    if (anchorless) {
        return /*#__PURE__*/ React.createElement(ListItemButton, {
            label: t('deviationview.tierCard.moreActionsMenu.item.goToTierDashboard'),
            onClick: openDashboard,
            fillContainerWidth: true,
            stopPropagation: stopPropagation
        });
    }
    return /*#__PURE__*/ React.createElement(ListItemLink, {
        label: t('deviationview.tierCard.moreActionsMenu.item.goToTierDashboard'),
        href: dashboardUrl,
        stopPropagation: stopPropagation
    });
};
GoToTierDashboard.displayName = 'GoToTierDashboard';
export default GoToTierDashboard;

//# sourceMappingURL=GoToTierDashboard.js.map